/**
 * Administration API Endpoints
 * Константы endpoints для микросервиса administration.
 */

export const AdministrationEndpoints = {
  // Menus
  Menu: "menu",
  MenuItem: "menu/by-slug/{slug}/menu-item",

  // Localizations
  Localization: "localizations",
  LocalizationExport: "localizations/export",
  LocalizationTemplateExport: "localizations/template-export",
  LocalizationImportPreview: "localizations/preview",
  LocalizationImport: "localizations/import",

  // Users & Roles
  User: "administration/users",
  UserRole: "administration/roles",
  UserPermission: "administration/app-permissions",
  AppUser: "app-user",
  BpUser: "bp-user",
  BpUserActivate: "bp-user/{id}/activate",
  BpUserInactivate: "bp-user/{id}/inactivate",
  Roles: "ref/app-roles",

  // App Modules
  AppModule: "administration/app-modules",

  // Settings
  SettingGroup: "setting-group",
  Setting: "setting-item/key/{key}",
  SettingItems: "setting-item",
  SettingById: "setting-item/{id}",

  // Auth
  Login: "administration/auth/login",
  RefreshToken: "administration/auth/refresh-token",

  // Partners
  BusinessPartner: "business-partner",
} as const;
